<template>
  <!-- 概况地图组件 -->
  <div class="OverviewMapBody">
    <MapInvestment :data="mapData" eheight="280px" :pointColor="'yellow'"></MapInvestment>

    <div class="mapCicleBox">
      <div class="mapCicle" v-for="(item, index) in mapData" :key="index" @click="changeInvestmentNewsList(item.region_name)">
        <!-- 此处未改完 -->
        {{ item.region_name_formatt }}
      </div>
    </div>
  </div>
</template>
<script>
// import MapInvestment from "@/components/MapInvestment.vue"
import MapInvestment from "@/components/MapInvestment.vue";
import { EventBus } from "../utils/eventBus.js";
export default {
  props: {
    mapData: Array
  },
  data() {
    return {
      activeNames: ["1"],
      controlIcon: true,
    };
  },
  components: {
    MapInvestment,
  },
  methods: {
    changeInvestmentNewsList(regionName){
      console.log('触发改变地区事件')
      EventBus.$emit('changeInvestmentRegionName',regionName)
    },
    changeIcon() {
      if (this.controlIcon) {
        // console.log('1')
        this.$refs.OverviewMapIcon.style =
          "transform: rotate(90deg);transition: all 0.3s linear;";
      } else {
        // console.log('2')
        this.$refs.OverviewMapIcon.style =
          "transform: rotate(0deg); transition: all 0.3s linear;";
      }
      this.controlIcon = !this.controlIcon;
    },
  },
};
</script>
<style lang="scss">
.OverviewMapBody {
  .van-cell {
    flex-direction: row-reverse;
  }
  .van-collapse-item__content {
    color: #555;
    padding-top: 0rem;
  }
  .iconImg {
    height: 0.15rem;
    margin-right: 0.1rem;
  }
  .contentImg {
    width: 100%;
    // height: 2.75rem;
  }
  .mapCicleBox {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-evenly;
    margin-top: 20px;
    .mapCicle {
      height: 60px;
      width: 60px;
      background: #81d3f8;
      border-radius: 30px;
      line-height: 60px;
      text-align: center;
      margin-right: 5px;
      margin-bottom: 5px;
      white-space: nowrap;
      overflow: hidden;
    }
    .mapCicle:hover{
      cursor: pointer;
    }
  }
}
</style>